<template>
    <div class="block ibox">
        <div class="ibox-title">
            <h3>Configurações</h3>
        </div>

        <div class="ibox-content">
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importCategories')">Importar Categorias</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importRecipes')">Importar Receitas</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importRecipeCategories')">Importar Categorias das Receitas</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importIngredients')">Importar Ingredientes</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importEquipments')">Importar Equipamentos</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importRecipeEquipments')">Importar Equipamentos das Receitas</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importRecipeCommonIngredients')">Importar Ingredientes Comuns</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importRecipeEmulzintIngredients')">Importar Ingredientes Emulzint</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importRecipeVideos')">Importar Vídeos das Receitas</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importRecipeImage')">Importar Imagens das Receitas</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importRecipeNutrition')">Importar Nutrição das Receitas</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importProducts')">Importar Produtos</button>
            <!-- <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importCustomers')">Importar Clientes</button> -->
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importProductImage')">Importar Imagens dos Produtos</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importProductNutritions')">Importar Nutrição dos Produtos</button>
            <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importProductIpro')">Importar Produtos do IPRO</button>
            <!-- <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importDistributors')">Importar Distribuidores</button> -->
            <!-- <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importCategoryProducts')">Importar Categoria dos Produtos</button> -->
            <!-- <button class="btn btn-primary m-r-sm m-b-sm" @click="importInformation('importIngredientsPrice')">Importar Preço dos Ingredientes</button> -->
        </div>

        <div class="ibox-title">
            <h3>Importações em Andamento</h3>
        </div>

        <div class="ibox-content">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Importação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="jobs.length === 0">
                        <td colspan="2" class="text-center">Nenhuma Ação em Execução</td>
                    </tr>
                    <tr v-if="jobs.length > 0" v-for="job in jobs">
                        <td style="width:20%;">{{ job.id }}</td>
                        <td>{{ job.importation }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                sequence: 0,
                jobs: 0,
            }
        },
        props: {},
        computed: {
            // Do nothing
        },
        mounted: function(){
            const func = this.checkImportations;

            this.interval = setInterval(function(){
                    func();
                }, 15000);
        },
        created: function(){
            let role = this.$store.getters.user.role;

            if(role !== 1){
                this.$router.push({path: '/'});
            }
        },
        methods: {
            importInformation: function(type){
                let self  = this;
                const api = self.$store.state.url;

                self.$http.get(api + 'import/' + type, {})
                    .then((response) => {
                        self.$message('Sucesso', 'Informações importadas com sucesso!', 'success');

                        self.checkImportations();
                    })
                    .catch((error) => {
                        self.$message('Ocorreu um erro ao tentar importar as informações solicitadas');
                    })
            },
            checkImportations: function(){
                let self  = this;
                const api = self.$store.state.url;

                self.$http.get(api + 'import/', {})
                    .then((response) => {
                        self.jobs = response.data;
                    })
                    .catch((error) => {
                        self.$message('Erro', 'Ocorreu um erro ao buscar as Importações Pendentes', 'error');
                    })
            }
        },
        beforeDestroy: function(){
            clearInterval(this.interval);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Configuration/Index.vue